
define('app/purchases/paypal/views/paypalView',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	//Views
	var PaypalPurchaseView = Backbone.View.extend({
		el: $("#payContent"),
		
		initialize: function(options) {
			this.paypalJSON = options.paypalJSON;
		},
		
		render: function () {
			this.hideAll();
			
			if(!this.paypalJSON || !this.paypalJSON.userAction){
				this.error();
			} else if (this.paypalJSON.dupPurch) {
				this.alreadyPurchased();
			} else if (this.paypalJSON.error) {
				this.error();
			} else if(this.paypalJSON.userAction == 'decline'){
				this.cancel();
			} else if(this.paypalJSON.userAction == 'accept' && this.paypalJSON.transaction){
				this.processPurchase(this.paypalJSON.transaction);
			} else {
				this.error();
			}
			
			return this;
		},
		
		processPurchase: function (transaction) {
			switch (transaction.payStatus) {
				case 'ACCEPTED':
					this.accept();
					break;
				case 'PENDING':
					this.pend();
					break;
				case 'CANCELLED':
					this.decline();
					break;
				default:
					this.error();
					break;
			}
		},
		
		hideAll: function() {
			this.$("#payError").hide();
			this.$("#payProcessing").hide();
			this.$("#payCancel").hide();
			this.$("#payAlreadyPurchased").hide();
			this.$("#payAccept").hide();
			this.$("#payPend").hide();
			this.$("#payDecline").hide();
		},
		
		error: function () {
			this.hideAll();
			this.$("#payError").show();
		},
		
		alreadyPurchased: function () {
			this.hideAll();
			this.$("#payAlreadyPurchased").show();
		},
		
		cancel: function () {
			this.hideAll();
			this.$("#payCancel").show();
		},
		
		accept: function () {
			this.hideAll();
			this.$("#payAccept").show();
		},
		
		pend: function () {
			this.hideAll();
			this.$("#payPend").show();
		},
		
		decline: function () {
			this.hideAll();
			this.$("#payDecline").show();
		},
	});
	
	return PaypalPurchaseView;  
});